import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, query, getDocs, orderBy, limit } from "firebase/firestore";
import { db } from "../../firebase";

const RecentSuccessStory = () => {
    const [mostRecentNews, setMostRecentNews] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const q = query(
        collection(db, "newsPosts"),
        orderBy("timestamp", "desc"),
        limit(1) // Limit to the most recent news post
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // If there is a recent news post, set it as the most recent news
        const doc = querySnapshot.docs[0];
        const data = doc.data();
        setMostRecentNews({ ...data, id: doc.id });
      } else {
        setMostRecentNews(null);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <section id="blog" className="blog">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 posts-list">
            {mostRecentNews ? (
              <div className="col-xl-10 col-md-10">
                <div className="post-item position-relative h-100">
                  <div className="post-img position-relative overflow-hidden">
                    <img
                      src={mostRecentNews.imageUrl}
                      alt="Success Story Image"
                      className="img-fluid"
                    />
                    <span className="post-date">Success Story</span>
                  </div>

                  <div className="blog-logo">
                    <h3>DG</h3>
                  </div>

                  <div className="post-content d-flex flex-column">
                    <Link to={`/journals/news/newsdetails/${mostRecentNews.id}`}>
                      <h3 className="post-title">{mostRecentNews.title}</h3>
                    </Link>
                    <div
                    className="content blog-content"
                    dangerouslySetInnerHTML={{ __html: mostRecentNews.content.slice(0, 300) }}
                  />
                  
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-xl-4 col-md-6">
                <p>No recent News available.</p>
              </div>
            )}
          </div>
        </div>
      </section>

    </div>
  );
};

export default RecentSuccessStory;
